module.exports = __webpack_public_path__ + "static/media/audio-03-ru.d7b0d9c3.mp3";